<template>
  <div class="profPolaznikManagmen-root">
    <v-tabs v-model="activeTab" color="#1976d2" dark slider-color="white">
      <v-tab v-for="tab in tabs" :key="tab.id" ripple> {{ tab.label }} </v-tab>
      <v-tab-item v-for="tab in tabs" :key="tab.id">
        <UsersFilter
          v-if="activeTab === 0 && showUsersFilter"
          :profesorId="profesorId"
          :isUserManagment="true"
          @polaznikDelete="onPolaznikDelete"
        />
        <PolaznikSearch v-if="activeTab === 1" @polaznikAdded="polaznikAdded"/>
      </v-tab-item>
    </v-tabs>
  </div>
</template>s
<script>
import UsersFilter from "./UsersFilter.vue";
import PolaznikSearch from "./UserSearch.vue";

export default {
  props: ["profesorId", "showUsersFilter"],
  components: {
    UsersFilter,
    PolaznikSearch
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        { id: 1, label: "Obrisi polaznika" },
        { id: 2, label: "Dodaj polaznika" },
      ],
    };
  },
  methods: {
    onPolaznikDelete(polaznikId) {
      this.$emit("polaznikDelete", polaznikId);
    },
    polaznikAdded(polaznik) {
      this.$emit("polaznikAdded", polaznik);
    }
  }
};
</script>
<style scoped>
.profPolaznikManagmen-root {
}
</style>
